import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUnpublishPack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (packId: number) => {
      return apiMutation('POST', {
        path: ENDPOINTS.unpublishPack,
        params: { packId: packId.toString() },
      }) as Promise<void>;
    },
    onSuccess: (_, packId) => {
      message.success(`Package #${packId} unpublished`);
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.packs],
        exact: false,
      });
    },
    onError: (_, packId) => {
      message.error(`Error while modifying packages #${packId}`);
    },
  });
}
